import React from 'react'
import { Link } from 'react-router-dom'
import styles from './Home.module.css'


const Home = () => {
    return (
      <div className={styles.hero}>
        <section className={styles.loginHero}>
          <div className={styles.overlay}>
              <h4 className={styles.title}>Identify West African bird species</h4>
              <p className={styles.text}>Welcome to the WABBIS Portal for species identification. Login to identify any bird species in West Africa</p>
              <div className={styles.button}>
                <Link style={{ textDecoration: 'none' }}  to="/login"><button className={styles.loginBtn} >Login to Start</button> </Link>
              </div>
          </div>
      </section>
      
      </div>

      
    )
}

export default Home
